// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"NoAccess_paginationPageDropdownWrap__+heTl","pageHeader":"NoAccess_pageHeader__kpQAK"};